export interface InstitutionCodeBookSearch {
    countyIds?: number[];
    municipalityIds?: number[];
    townIds?: number[];
    ids?: number[];

    /**
     * Whether or not to include institutions which are not currently Active. 
     * This means StatusId is Active and at least one Program for enrollment in 
     * the current school year.
     */
    onlyActive: boolean;
    /**
     * Whether or not to include institutions which are not for enrollment.
     */
    includeOutsideEnrollmentArea: boolean;
    /**
     * Whether or not to include TUR institutions. Null means don't filter. 
     * True means only TUR institutions. False means only not TUR institutions.
     */
    includeHandicapped?: boolean;
    /**
     * Whether or not to include satellite institutions. Null means don't filter. 
     * True means only satellite institutions. False means only not satellite institutions.
     */
    includeSatellite?: boolean;
    /**
     * Whether or not to include private institutions. Null means don't filter. 
     * True means only private institutions. False means only not private institutions.
     */
     includePrivate?: boolean;

     /**
      * A string which must appear in the institution name. This does not incude 
      * the town name.
      */
     search?: string;
}

export const getInstitutionCodeBookSearch = (): InstitutionCodeBookSearch => {
    return {
        onlyActive: false,
        includeOutsideEnrollmentArea: false,
    };
};